import * as React from "react"
import {withStyles, WithStyles, StyleRules, ClassNameMap} from "@mui/styles"
import AppView from "~common/components/app-view/index"
import LoadingView from "~common/components/loading-view"
import {Theme} from "@mui/styles"
import Require from "~common/components/require"
import ExternalLinkEditView from "~links/components/links-edit-view-new"
import ExternalLinkQueryList from "~links/components/link-query-list-view"
import {Typography} from '@mui/material'


const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
  },
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any
}

type State = {
  status: "loading" | "ready"
}

class ExternalLinkAdmin extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {status: "ready"}
  }

  render() {

    const {match} = this.props 
    const { classes, history}: {classes: ClassNameMap; history: any} = this.props
    const { status} = this.state

    var selectedExternalLinkID
    if(match && match.params && match.params.id) {
      selectedExternalLinkID = match.params.id
    }

    var view 
    if (status === "loading") {
      view = <LoadingView classes={{}} />
    } else if (selectedExternalLinkID) {
      view = <ExternalLinkEditView match={match} externallinkId={selectedExternalLinkID} history={history} classes={{}} />
    } else {
      view = <ExternalLinkQueryList></ExternalLinkQueryList> 
    }

    return (
      <AppView>
        <Require classes={{}} requireOneOfFeatures={["link_admin"]}>
            <Typography id="externallinkAdminTitle" variant="h5" className={classes.heading}>
               Links Administration
            </Typography>
            <div className={classes.container}>{view}</div>
        </Require>
      </AppView>
    )
  }
}

export default withStyles(styles)(ExternalLinkAdmin)
